export const GET_MILLICAST_TOKEN = 'BROADCAST/GET_MILLICAST_TOKEN';
export const TOKEN_ERROR = 'BROADCAST/ERROR';
export const BROADCAST_DATA_RESET = 'BROADCAST/DATA_RESET';

const initialState = {
  token: undefined,
  error: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MILLICAST_TOKEN:
      return {
        ...state,
        token: action.payload
      };
    case TOKEN_ERROR:
      return {
        ...state,
        error: action.payload
      };
    case BROADCAST_DATA_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
